// extracted by mini-css-extract-plugin
module.exports = {"root":"root--n7Vdk","list":"list--yRLAP"};